import React, { useState, useEffect } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { getCurrentUser } from "../../../helpers/Utils"
import axios from "axios"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import FetchWeb from "./fetch-webhook"

let selectedRoleId = []

const FetchWlist = props => {
  const [fetch, setFetch] = useState(props.data)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [isOpen, setIsOpen] = useState(false)
  const [nwemodal_standard, setnewModal_standard] = useState(false)

  const deleteFetch = e => {
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/delete-webhook/${e} `,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setFetch("")
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }

  const editFetch = () => {
    setIsOpen(true)
    setnewModal_standard(true)
  }

  useEffect(() => {
    selectedRoleId = []
  }, [])

  const getSelectedId = (e, check) => {
    if (check.target.checked) {
      selectedRoleId.push(e)
      const uniqueID = selectedRoleId.filter((val, id, array) => {
        return array.indexOf(val) == id
      })
      selectedRoleId = uniqueID
      props.setLeadsSelectedIds(selectedRoleId)
    } else {
      selectedRoleId = props.leadsSelectedIds
      var array = selectedRoleId
      var index = array.indexOf(e)
      if (index !== -1) {
        array.splice(index, 1)
      }
      props.setLeadsSelectedIds(selectedRoleId)
    }
    if (selectedRoleId.length == 0) {
      props.setBlur(false)
    } else {
      props.setBlur(true)
    }
  }

  if (fetch === "") {
    return ""
  } else
    return (
      <>
        {isOpen ? (
          <FetchWeb
            nwemodal_standard={nwemodal_standard}
            setnewModal_standard={setnewModal_standard}
            fetch={fetch}
            setFetch={setFetch}
            setIsOpen={setIsOpen}
          />
        ) : null}
        <tr key={props.i}>
          <td>{props.counter3 + props.i}</td>
          <td>{fetch.api_key}</td>
          <td>{fetch.platform}</td>
          <td>{fetch.leadsource}</td>
          <td>
            {fetch.assigneename?.length > 0 && (
              <div className="mb-2">
                <span className="badge bg-primary me-1">Individual:</span>
                {fetch.assigneename.map((item, i) => (
                  <span key={i}>
                    {item.name}
                    {i < fetch.assigneename.length - 1 && ", "}
                  </span>
                ))}
              </div>
            )}
            {fetch.group_user_assignments?.length > 0 && (
              <div>
                <span className="badge bg-success me-1">Groups:</span>
                {fetch.group_user_assignments.map((groupAssignment, i) => (
                  <div key={i} className="ms-2 mb-1">
                    <strong className="text-success">
                      {groupAssignment?.group || "Unknown Group"}:
                    </strong>{" "}
                    {groupAssignment?.users?.map((user, j) => (
                      <span key={j}>
                        {user.name}
                        {j < groupAssignment.users.length - 1 && ", "}
                      </span>
                    )) || <span className="text-muted">No users</span>}
                  </div>
                ))}
              </div>
            )}
            {(!fetch.assigneename || fetch.assigneename.length === 0) &&
              (!fetch.group_user_assignments ||
                fetch.group_user_assignments.length === 0) && (
                <span className="text-muted">Admin</span>
              )}
          </td>
          <td>{fetch.latest_leads_only === 1 ? "Yes" : "No"}</td>
          <td>
            <a
              className="text-warning"
              onClick={() => {
                editFetch(fetch.id)
              }}
            >
              <i className="fas fa-pen" />
            </a>
            <a
              className="text-danger ms-2"
              onClick={() => {
                setconfirm_alert(true)
              }}
            >
              <i className="fas fa-trash-alt" />
            </a>
            {confirm_alert ? (
              <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmButtonText="Yes, delete it!"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setconfirm_alert(false)
                  setsuccess_dlg(true)
                  deleteFetch(fetch.id)
                  setdynamic_title("Deleted")
                  setdynamic_description("Your file has been deleted.")
                }}
                onCancel={() => setconfirm_alert(false)}
              >
                You won't be able to revert this!
              </SweetAlert>
            ) : null}
          </td>
        </tr>
      </>
    )
}
export default FetchWlist
